// extracted by mini-css-extract-plugin
export default {"wrapper":"collaboration_wrapper__c1bWe","title":"collaboration_title__aDpcD","mobile":"collaboration_mobile__eSKI6","desktop":"collaboration_desktop__1gtv4"};